import { render, staticRenderFns } from "./SelectItemsWithEditor.vue?vue&type=template&id=6de65209&"
import script from "./SelectItemsWithEditor.vue?vue&type=script&lang=js&"
export * from "./SelectItemsWithEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports